import { render, staticRenderFns } from "./GroupTypeSort.vue?vue&type=template&id=4e223661&scoped=true"
import script from "./GroupTypeSort.vue?vue&type=script&lang=js"
export * from "./GroupTypeSort.vue?vue&type=script&lang=js"
import style0 from "./GroupTypeSort.vue?vue&type=style&index=0&id=4e223661&prod&lang=scss"
import style1 from "./GroupTypeSort.vue?vue&type=style&index=1&id=4e223661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e223661",
  null
  
)

export default component.exports